export const sortDatesWorkFlowToolBar = (sortedWorkflows, sortInfo) => {
              if (sortInfo?.field && sortInfo?.order) {
                const { field, order } = sortInfo;
                const isAscending = order === "ascend";

                const parseCustomDate = (val) => {
                    if (typeof val !== 'string') return null;
                    
                    const parts = val.split('/');
                    if (parts.length === 3) {
                        const [day, month, year] = parts.map(Number);
                        const date = new Date(year, month - 1, day);
                        return !isNaN(date.getTime()) ? date : null;
                    }

                    const date = new Date(val);
                    return !isNaN(date.getTime()) ? date : null;
                };

               return sortedWorkflows.sort((a, b) => {
                    let valA = a[field];
                    let valB = b[field];

                    const dateA = parseCustomDate(valA);
                    const dateB = parseCustomDate(valB);

                    if (dateA && dateB) {
                        return isAscending 
                            ? dateA.getTime() - dateB.getTime() 
                            : dateB.getTime() - dateA.getTime();
                    }

                    if (typeof valA === 'string' && typeof valB === 'string') {
                        return isAscending 
                            ? valA.localeCompare(valB) 
                            : valB.localeCompare(valA);
                    }

                    return 0;
                });
            }
}